import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-interview-notes',
  standalone: true,
  imports: [FormsModule, SharedModule],
  templateUrl: './interview-notes.component.html',
  styleUrl: './interview-notes.component.scss',
})
export class InterviewNotesComponent {
  @Input() noteText: string | undefined = '';
  @Input() textEditable: boolean = false;
  @Output() noteTextChange = new EventEmitter<string>();

  onTextChange(value: string): void {
    this.noteTextChange.emit(value);
  }
}
